<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="RankProgress" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { RankProgressProps } from './RankProgress.ts';
import RankProgress from './RankProgress.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-rank-progress';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<RankProgressProps>();
const changableProps = useChangableProps(componentName, props);

</script>
